import PhoneInput from 'react-phone-input-2';

window.ReactPhoneInput = PhoneInput;
